import { render, staticRenderFns } from "./FamousPediaCreate.vue?vue&type=template&id=18e591ee&"
import script from "./FamousPediaCreate.vue?vue&type=script&lang=js&"
export * from "./FamousPediaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports